// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * animations.css - Enhanced CSS Animations for Memex Racing
 * 
 * Provides CSS-based animations for UI elements including:
 * - Panel transitions
 * - Loading animations
 * - Countdown effects
 * - Winner celebrations
 * - Retro gaming effects
 */

/* ===== KEYFRAME DEFINITIONS ===== */

/* Panel Slide Animations */
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideInRight {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideInTop {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideInBottom {
    from {
        transform: translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Fade Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

/* Scale Animations */
@keyframes zoomIn {
    from {
        transform: scale(0);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes zoomOut {
    from {
        transform: scale(1);
        opacity: 1;
    }
    to {
        transform: scale(0);
        opacity: 0;
    }
}

@keyframes bounceIn {
    0% {
        transform: scale(0.3);
        opacity: 0;
    }
    50% {
        transform: scale(1.05);
    }
    70% {
        transform: scale(0.9);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* Attention Animations */
@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

@keyframes shake {
    0%, 100% {
        transform: translateX(0);
    }
    10%, 30%, 50%, 70%, 90% {
        transform: translateX(-10px);
    }
    20%, 40%, 60%, 80% {
        transform: translateX(10px);
    }
}

@keyframes rubberBand {
    0% {
        transform: scale(1);
    }
    30% {
        transform: scale(1.25, 0.75);
    }
    40% {
        transform: scale(0.75, 1.25);
    }
    50% {
        transform: scale(1.15, 0.85);
    }
    65% {
        transform: scale(0.95, 1.05);
    }
    75% {
        transform: scale(1.05, 0.95);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes flash {
    0%, 50%, 100% {
        opacity: 1;
    }
    25%, 75% {
        opacity: 0;
    }
}

/* Rotation Animations */
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes spinReverse {
    from {
        transform: rotate(360deg);
    }
    to {
        transform: rotate(0deg);
    }
}

/* Glow Effect */
@keyframes glow {
    0%, 100% {
        box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
    }
    50% {
        box-shadow: 0 0 30px rgba(0, 255, 0, 0.8),
                    0 0 50px rgba(0, 255, 0, 0.6),
                    0 0 70px rgba(0, 255, 0, 0.4);
    }
}

@keyframes textGlow {
    0%, 100% {
        text-shadow: 0 0 5px rgba(0, 255, 0, 0.5);
    }
    50% {
        text-shadow: 0 0 20px rgba(0, 255, 0, 1),
                     0 0 30px rgba(0, 255, 0, 0.8),
                     0 0 40px rgba(0, 255, 0, 0.6);
    }
}

/* Loading Animations */
@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes loadingDots {
    0%, 80%, 100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
}

@keyframes progressBar {
    from {
        width: 0%;
    }
    to {
        width: 100%;
    }
}

/* Countdown Animations */
@keyframes countdownPulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.5);
        opacity: 0.7;
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
}

@keyframes countdownBounce {
    0% {
        transform: scale(0) rotate(0deg);
        opacity: 0;
    }
    50% {
        transform: scale(1.2) rotate(180deg);
        opacity: 1;
    }
    100% {
        transform: scale(1) rotate(360deg);
        opacity: 1;
    }
}

/* Winner Celebration Animations */
@keyframes celebrate {
    0%, 100% {
        transform: scale(1) rotate(0deg);
    }
    25% {
        transform: scale(1.1) rotate(5deg);
    }
    50% {
        transform: scale(1.2) rotate(-5deg);
    }
    75% {
        transform: scale(1.1) rotate(5deg);
    }
}

@keyframes confetti {
    0% {
        transform: translateY(-100vh) rotate(0deg);
        opacity: 1;
    }
    100% {
        transform: translateY(100vh) rotate(720deg);
        opacity: 0;
    }
}

@keyframes trophy {
    0% {
        transform: scale(0) rotate(0deg);
    }
    50% {
        transform: scale(1.2) rotate(360deg);
    }
    100% {
        transform: scale(1) rotate(720deg);
    }
}

/* Retro Gaming Effects */
@keyframes scanlines {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: 0 10px;
    }
}

@keyframes glitch {
    0%, 100% {
        transform: translateX(0);
        filter: hue-rotate(0deg);
    }
    20% {
        transform: translateX(-2px);
        filter: hue-rotate(90deg);
    }
    40% {
        transform: translateX(2px);
        filter: hue-rotate(180deg);
    }
    60% {
        transform: translateX(-2px);
        filter: hue-rotate(270deg);
    }
    80% {
        transform: translateX(2px);
        filter: hue-rotate(360deg);
    }
}

@keyframes pixelate {
    0%, 100% {
        filter: blur(0);
    }
    50% {
        filter: blur(1px);
    }
}

@keyframes typewriter {
    from {
        width: 0;
    }
    to {
        width: 100%;
    }
}

@keyframes blink {
    0%, 49% {
        opacity: 1;
    }
    50%, 100% {
        opacity: 0;
    }
}

/* Matrix Rain Effect */
@keyframes matrixRain {
    0% {
        transform: translateY(-100%);
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        transform: translateY(100vh);
        opacity: 0;
    }
}

/* ===== ANIMATION CLASSES ===== */

/* Entrance Animations */
.animate-fadeIn {
    animation: fadeIn 0.3s ease-out forwards;
}

.animate-slideInLeft {
    animation: slideInLeft 0.4s ease-out forwards;
}

.animate-slideInRight {
    animation: slideInRight 0.4s ease-out forwards;
}

.animate-slideInTop {
    animation: slideInTop 0.4s ease-out forwards;
}

.animate-slideInBottom {
    animation: slideInBottom 0.4s ease-out forwards;
}

.animate-zoomIn {
    animation: zoomIn 0.35s ease-out forwards;
}

.animate-bounceIn {
    animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
}

/* Exit Animations */
.animate-fadeOut {
    animation: fadeOut 0.3s ease-in forwards;
}

.animate-zoomOut {
    animation: zoomOut 0.35s ease-in forwards;
}

/* Attention Animations */
.animate-pulse {
    animation: pulse 1s ease-in-out infinite;
}

.animate-shake {
    animation: shake 0.5s ease-in-out;
}

.animate-rubberBand {
    animation: rubberBand 1s ease-in-out;
}

.animate-flash {
    animation: flash 0.5s ease-in-out;
}

.animate-spin {
    animation: spin 1s linear infinite;
}

.animate-glow {
    animation: glow 2s ease-in-out infinite;
}

.animate-textGlow {
    animation: textGlow 2s ease-in-out infinite;
}

/* Loading States */
.loading-spinner {
    animation: loading 1s linear infinite;
}

.loading-dots span {
    animation: loadingDots 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
    animation-delay: -0.16s;
}

.progress-bar {
    animation: progressBar 2s ease-out forwards;
}

/* Countdown Effects */
.countdown-number {
    animation: countdownBounce 1s ease-out;
}

.countdown-pulse {
    animation: countdownPulse 1s ease-out;
}

/* Winner Effects */
.winner-celebration {
    animation: celebrate 2s ease-in-out infinite;
}

.winner-trophy {
    animation: trophy 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.confetti-piece {
    animation: confetti 3s linear forwards;
}

/* Retro Effects */
.retro-scanlines {
    position: relative;
}

.retro-scanlines::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(0, 255, 0, 0.03) 2px,
        rgba(0, 255, 0, 0.03) 4px
    );
    animation: scanlines 8s linear infinite;
    pointer-events: none;
}

.retro-glitch {
    animation: glitch 2s steps(20) infinite;
}

.retro-pixelate {
    animation: pixelate 0.5s steps(5) infinite;
}

.typewriter-text {
    overflow: hidden;
    border-right: 2px solid #00ff00;
    white-space: nowrap;
    animation: typewriter 3s steps(40) 1s 1 normal both,
               blink 1s steps(2) infinite;
}

/* ===== ANIMATION UTILITIES ===== */

/* Animation Delays */
.delay-100 { animation-delay: 100ms; }
.delay-200 { animation-delay: 200ms; }
.delay-300 { animation-delay: 300ms; }
.delay-400 { animation-delay: 400ms; }
.delay-500 { animation-delay: 500ms; }
.delay-1000 { animation-delay: 1000ms; }

/* Animation Durations */
.duration-fast { animation-duration: 200ms; }
.duration-normal { animation-duration: 300ms; }
.duration-slow { animation-duration: 500ms; }
.duration-slower { animation-duration: 1000ms; }
.duration-slowest { animation-duration: 2000ms; }

/* Animation Fill Modes */
.fill-forwards { animation-fill-mode: forwards; }
.fill-backwards { animation-fill-mode: backwards; }
.fill-both { animation-fill-mode: both; }

/* Animation Iteration */
.animate-once { animation-iteration-count: 1; }
.animate-twice { animation-iteration-count: 2; }
.animate-infinite { animation-iteration-count: infinite; }

/* ===== TRANSITION CLASSES ===== */

.transition-all {
    transition: all 0.3s ease;
}

.transition-opacity {
    transition: opacity 0.3s ease;
}

.transition-transform {
    transition: transform 0.3s ease;
}

.transition-colors {
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.transition-shadow {
    transition: box-shadow 0.3s ease;
}

/* Hover Effects */
.hover-grow:hover {
    transform: scale(1.05);
}

.hover-shrink:hover {
    transform: scale(0.95);
}

.hover-rotate:hover {
    transform: rotate(5deg);
}

.hover-glow:hover {
    box-shadow: 0 0 20px rgba(0, 255, 0, 0.8);
}

.hover-lift:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}

/* Active States */
.active-scale:active {
    transform: scale(0.95);
}

.active-darken:active {
    filter: brightness(0.8);
}

/* Disabled States */
.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

/* ===== SPECIAL EFFECTS ===== */

/* Neon Text Effect */
.neon-text {
    text-shadow: 
        0 0 10px #00ff00,
        0 0 20px #00ff00,
        0 0 30px #00ff00,
        0 0 40px #00ff00;
}

/* CRT Monitor Effect */
.crt-effect {
    position: relative;
    overflow: hidden;
}

.crt-effect::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        rgba(18, 16, 16, 0) 50%,
        rgba(0, 0, 0, 0.25) 50%
    );
    background-size: 100% 2px;
    pointer-events: none;
    z-index: 1;
}

.crt-effect::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 255, 0, 0.02);
    pointer-events: none;
    z-index: 2;
}

/* Pixelated Images */
.pixelated {
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/animations.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF,qCAAqC;;AAErC,2BAA2B;AAC3B;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,oBAAoB;AACpB;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA,qBAAqB;AACrB;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,yBAAyB;AACzB;IACI;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA,wBAAwB;AACxB;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,uBAAuB;IAC3B;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,yCAAyC;IAC7C;IACA;QACI;;iDAEyC;IAC7C;AACJ;;AAEA;IACI;QACI,yCAAyC;IAC7C;IACA;QACI;;kDAE0C;IAC9C;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,WAAW;IACf;AACJ;;AAEA,yBAAyB;AACzB;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gCAAgC;QAChC,UAAU;IACd;IACA;QACI,oCAAoC;QACpC,UAAU;IACd;IACA;QACI,kCAAkC;QAClC,UAAU;IACd;AACJ;;AAEA,kCAAkC;AAClC;IACI;QACI,gCAAgC;IACpC;IACA;QACI,kCAAkC;IACtC;IACA;QACI,mCAAmC;IACvC;IACA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,0CAA0C;QAC1C,UAAU;IACd;IACA;QACI,2CAA2C;QAC3C,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;IACA;QACI,oCAAoC;IACxC;IACA;QACI,kCAAkC;IACtC;AACJ;;AAEA,yBAAyB;AACzB;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;IACA;QACI,2BAA2B;QAC3B,yBAAyB;IAC7B;IACA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;IACA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,4BAA4B;QAC5B,UAAU;IACd;AACJ;;AAEA,kCAAkC;;AAElC,wBAAwB;AACxB;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wEAAwE;AAC5E;;AAEA,oBAAoB;AACpB;IACI,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,yBAAyB;AACzB;IACI,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,mBAAmB;AACnB;IACI,qCAAqC;AACzC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,sBAAsB;AACtB;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;;AAEA,mBAAmB;AACnB;IACI,4CAA4C;AAChD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;;;;KAMC;IACD,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB;yCACqC;AACzC;;AAEA,oCAAoC;;AAEpC,qBAAqB;AACrB,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;AACrC,cAAc,uBAAuB,EAAE;;AAEvC,wBAAwB;AACxB,iBAAiB,yBAAyB,EAAE;AAC5C,mBAAmB,yBAAyB,EAAE;AAC9C,iBAAiB,yBAAyB,EAAE;AAC5C,mBAAmB,0BAA0B,EAAE;AAC/C,oBAAoB,0BAA0B,EAAE;;AAEhD,yBAAyB;AACzB,iBAAiB,6BAA6B,EAAE;AAChD,kBAAkB,8BAA8B,EAAE;AAClD,aAAa,yBAAyB,EAAE;;AAExC,wBAAwB;AACxB,gBAAgB,4BAA4B,EAAE;AAC9C,iBAAiB,4BAA4B,EAAE;AAC/C,oBAAoB,mCAAmC,EAAE;;AAEzD,mCAAmC;;AAEnC;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,gCAAgC;AACpC;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,gCAAgC;;AAEhC,qBAAqB;AACrB;IACI;;;;wBAIoB;AACxB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;KAGC;IACD,yBAAyB;IACzB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,oBAAoB;IACpB,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC","sourcesContent":["/**\n * animations.css - Enhanced CSS Animations for Memex Racing\n * \n * Provides CSS-based animations for UI elements including:\n * - Panel transitions\n * - Loading animations\n * - Countdown effects\n * - Winner celebrations\n * - Retro gaming effects\n */\n\n/* ===== KEYFRAME DEFINITIONS ===== */\n\n/* Panel Slide Animations */\n@keyframes slideInLeft {\n    from {\n        transform: translateX(-100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n@keyframes slideInRight {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n@keyframes slideInTop {\n    from {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes slideInBottom {\n    from {\n        transform: translateY(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n/* Fade Animations */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1;\n    }\n    to {\n        opacity: 0;\n    }\n}\n\n/* Scale Animations */\n@keyframes zoomIn {\n    from {\n        transform: scale(0);\n        opacity: 0;\n    }\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes zoomOut {\n    from {\n        transform: scale(1);\n        opacity: 1;\n    }\n    to {\n        transform: scale(0);\n        opacity: 0;\n    }\n}\n\n@keyframes bounceIn {\n    0% {\n        transform: scale(0.3);\n        opacity: 0;\n    }\n    50% {\n        transform: scale(1.05);\n    }\n    70% {\n        transform: scale(0.9);\n    }\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* Attention Animations */\n@keyframes pulse {\n    0%, 100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.05);\n    }\n}\n\n@keyframes shake {\n    0%, 100% {\n        transform: translateX(0);\n    }\n    10%, 30%, 50%, 70%, 90% {\n        transform: translateX(-10px);\n    }\n    20%, 40%, 60%, 80% {\n        transform: translateX(10px);\n    }\n}\n\n@keyframes rubberBand {\n    0% {\n        transform: scale(1);\n    }\n    30% {\n        transform: scale(1.25, 0.75);\n    }\n    40% {\n        transform: scale(0.75, 1.25);\n    }\n    50% {\n        transform: scale(1.15, 0.85);\n    }\n    65% {\n        transform: scale(0.95, 1.05);\n    }\n    75% {\n        transform: scale(1.05, 0.95);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes flash {\n    0%, 50%, 100% {\n        opacity: 1;\n    }\n    25%, 75% {\n        opacity: 0;\n    }\n}\n\n/* Rotation Animations */\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spinReverse {\n    from {\n        transform: rotate(360deg);\n    }\n    to {\n        transform: rotate(0deg);\n    }\n}\n\n/* Glow Effect */\n@keyframes glow {\n    0%, 100% {\n        box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);\n    }\n    50% {\n        box-shadow: 0 0 30px rgba(0, 255, 0, 0.8),\n                    0 0 50px rgba(0, 255, 0, 0.6),\n                    0 0 70px rgba(0, 255, 0, 0.4);\n    }\n}\n\n@keyframes textGlow {\n    0%, 100% {\n        text-shadow: 0 0 5px rgba(0, 255, 0, 0.5);\n    }\n    50% {\n        text-shadow: 0 0 20px rgba(0, 255, 0, 1),\n                     0 0 30px rgba(0, 255, 0, 0.8),\n                     0 0 40px rgba(0, 255, 0, 0.6);\n    }\n}\n\n/* Loading Animations */\n@keyframes loading {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes loadingDots {\n    0%, 80%, 100% {\n        opacity: 0;\n    }\n    40% {\n        opacity: 1;\n    }\n}\n\n@keyframes progressBar {\n    from {\n        width: 0%;\n    }\n    to {\n        width: 100%;\n    }\n}\n\n/* Countdown Animations */\n@keyframes countdownPulse {\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(1.5);\n        opacity: 0.7;\n    }\n    100% {\n        transform: scale(2);\n        opacity: 0;\n    }\n}\n\n@keyframes countdownBounce {\n    0% {\n        transform: scale(0) rotate(0deg);\n        opacity: 0;\n    }\n    50% {\n        transform: scale(1.2) rotate(180deg);\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1) rotate(360deg);\n        opacity: 1;\n    }\n}\n\n/* Winner Celebration Animations */\n@keyframes celebrate {\n    0%, 100% {\n        transform: scale(1) rotate(0deg);\n    }\n    25% {\n        transform: scale(1.1) rotate(5deg);\n    }\n    50% {\n        transform: scale(1.2) rotate(-5deg);\n    }\n    75% {\n        transform: scale(1.1) rotate(5deg);\n    }\n}\n\n@keyframes confetti {\n    0% {\n        transform: translateY(-100vh) rotate(0deg);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100vh) rotate(720deg);\n        opacity: 0;\n    }\n}\n\n@keyframes trophy {\n    0% {\n        transform: scale(0) rotate(0deg);\n    }\n    50% {\n        transform: scale(1.2) rotate(360deg);\n    }\n    100% {\n        transform: scale(1) rotate(720deg);\n    }\n}\n\n/* Retro Gaming Effects */\n@keyframes scanlines {\n    0% {\n        background-position: 0 0;\n    }\n    100% {\n        background-position: 0 10px;\n    }\n}\n\n@keyframes glitch {\n    0%, 100% {\n        transform: translateX(0);\n        filter: hue-rotate(0deg);\n    }\n    20% {\n        transform: translateX(-2px);\n        filter: hue-rotate(90deg);\n    }\n    40% {\n        transform: translateX(2px);\n        filter: hue-rotate(180deg);\n    }\n    60% {\n        transform: translateX(-2px);\n        filter: hue-rotate(270deg);\n    }\n    80% {\n        transform: translateX(2px);\n        filter: hue-rotate(360deg);\n    }\n}\n\n@keyframes pixelate {\n    0%, 100% {\n        filter: blur(0);\n    }\n    50% {\n        filter: blur(1px);\n    }\n}\n\n@keyframes typewriter {\n    from {\n        width: 0;\n    }\n    to {\n        width: 100%;\n    }\n}\n\n@keyframes blink {\n    0%, 49% {\n        opacity: 1;\n    }\n    50%, 100% {\n        opacity: 0;\n    }\n}\n\n/* Matrix Rain Effect */\n@keyframes matrixRain {\n    0% {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n    10% {\n        opacity: 1;\n    }\n    90% {\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100vh);\n        opacity: 0;\n    }\n}\n\n/* ===== ANIMATION CLASSES ===== */\n\n/* Entrance Animations */\n.animate-fadeIn {\n    animation: fadeIn 0.3s ease-out forwards;\n}\n\n.animate-slideInLeft {\n    animation: slideInLeft 0.4s ease-out forwards;\n}\n\n.animate-slideInRight {\n    animation: slideInRight 0.4s ease-out forwards;\n}\n\n.animate-slideInTop {\n    animation: slideInTop 0.4s ease-out forwards;\n}\n\n.animate-slideInBottom {\n    animation: slideInBottom 0.4s ease-out forwards;\n}\n\n.animate-zoomIn {\n    animation: zoomIn 0.35s ease-out forwards;\n}\n\n.animate-bounceIn {\n    animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;\n}\n\n/* Exit Animations */\n.animate-fadeOut {\n    animation: fadeOut 0.3s ease-in forwards;\n}\n\n.animate-zoomOut {\n    animation: zoomOut 0.35s ease-in forwards;\n}\n\n/* Attention Animations */\n.animate-pulse {\n    animation: pulse 1s ease-in-out infinite;\n}\n\n.animate-shake {\n    animation: shake 0.5s ease-in-out;\n}\n\n.animate-rubberBand {\n    animation: rubberBand 1s ease-in-out;\n}\n\n.animate-flash {\n    animation: flash 0.5s ease-in-out;\n}\n\n.animate-spin {\n    animation: spin 1s linear infinite;\n}\n\n.animate-glow {\n    animation: glow 2s ease-in-out infinite;\n}\n\n.animate-textGlow {\n    animation: textGlow 2s ease-in-out infinite;\n}\n\n/* Loading States */\n.loading-spinner {\n    animation: loading 1s linear infinite;\n}\n\n.loading-dots span {\n    animation: loadingDots 1.4s infinite ease-in-out both;\n}\n\n.loading-dots span:nth-child(1) {\n    animation-delay: -0.32s;\n}\n\n.loading-dots span:nth-child(2) {\n    animation-delay: -0.16s;\n}\n\n.progress-bar {\n    animation: progressBar 2s ease-out forwards;\n}\n\n/* Countdown Effects */\n.countdown-number {\n    animation: countdownBounce 1s ease-out;\n}\n\n.countdown-pulse {\n    animation: countdownPulse 1s ease-out;\n}\n\n/* Winner Effects */\n.winner-celebration {\n    animation: celebrate 2s ease-in-out infinite;\n}\n\n.winner-trophy {\n    animation: trophy 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.confetti-piece {\n    animation: confetti 3s linear forwards;\n}\n\n/* Retro Effects */\n.retro-scanlines {\n    position: relative;\n}\n\n.retro-scanlines::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: repeating-linear-gradient(\n        0deg,\n        transparent,\n        transparent 2px,\n        rgba(0, 255, 0, 0.03) 2px,\n        rgba(0, 255, 0, 0.03) 4px\n    );\n    animation: scanlines 8s linear infinite;\n    pointer-events: none;\n}\n\n.retro-glitch {\n    animation: glitch 2s steps(20) infinite;\n}\n\n.retro-pixelate {\n    animation: pixelate 0.5s steps(5) infinite;\n}\n\n.typewriter-text {\n    overflow: hidden;\n    border-right: 2px solid #00ff00;\n    white-space: nowrap;\n    animation: typewriter 3s steps(40) 1s 1 normal both,\n               blink 1s steps(2) infinite;\n}\n\n/* ===== ANIMATION UTILITIES ===== */\n\n/* Animation Delays */\n.delay-100 { animation-delay: 100ms; }\n.delay-200 { animation-delay: 200ms; }\n.delay-300 { animation-delay: 300ms; }\n.delay-400 { animation-delay: 400ms; }\n.delay-500 { animation-delay: 500ms; }\n.delay-1000 { animation-delay: 1000ms; }\n\n/* Animation Durations */\n.duration-fast { animation-duration: 200ms; }\n.duration-normal { animation-duration: 300ms; }\n.duration-slow { animation-duration: 500ms; }\n.duration-slower { animation-duration: 1000ms; }\n.duration-slowest { animation-duration: 2000ms; }\n\n/* Animation Fill Modes */\n.fill-forwards { animation-fill-mode: forwards; }\n.fill-backwards { animation-fill-mode: backwards; }\n.fill-both { animation-fill-mode: both; }\n\n/* Animation Iteration */\n.animate-once { animation-iteration-count: 1; }\n.animate-twice { animation-iteration-count: 2; }\n.animate-infinite { animation-iteration-count: infinite; }\n\n/* ===== TRANSITION CLASSES ===== */\n\n.transition-all {\n    transition: all 0.3s ease;\n}\n\n.transition-opacity {\n    transition: opacity 0.3s ease;\n}\n\n.transition-transform {\n    transition: transform 0.3s ease;\n}\n\n.transition-colors {\n    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n}\n\n.transition-shadow {\n    transition: box-shadow 0.3s ease;\n}\n\n/* Hover Effects */\n.hover-grow:hover {\n    transform: scale(1.05);\n}\n\n.hover-shrink:hover {\n    transform: scale(0.95);\n}\n\n.hover-rotate:hover {\n    transform: rotate(5deg);\n}\n\n.hover-glow:hover {\n    box-shadow: 0 0 20px rgba(0, 255, 0, 0.8);\n}\n\n.hover-lift:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);\n}\n\n/* Active States */\n.active-scale:active {\n    transform: scale(0.95);\n}\n\n.active-darken:active {\n    filter: brightness(0.8);\n}\n\n/* Disabled States */\n.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n/* ===== SPECIAL EFFECTS ===== */\n\n/* Neon Text Effect */\n.neon-text {\n    text-shadow: \n        0 0 10px #00ff00,\n        0 0 20px #00ff00,\n        0 0 30px #00ff00,\n        0 0 40px #00ff00;\n}\n\n/* CRT Monitor Effect */\n.crt-effect {\n    position: relative;\n    overflow: hidden;\n}\n\n.crt-effect::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n        rgba(18, 16, 16, 0) 50%,\n        rgba(0, 0, 0, 0.25) 50%\n    );\n    background-size: 100% 2px;\n    pointer-events: none;\n    z-index: 1;\n}\n\n.crt-effect::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 255, 0, 0.02);\n    pointer-events: none;\n    z-index: 2;\n}\n\n/* Pixelated Images */\n.pixelated {\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
